// extracted by mini-css-extract-plugin
export default {"spcard__container":"projectCard_spcard__container__G9mn6","spcard__card":"projectCard_spcard__card__Cqgkt"};